/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { MessagesState } from "~/features/messages/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.messages;

const createSelector =
  <TSelected = unknown>(selector: (state: MessagesState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

export const selectMessagesData = createSelector((state) => state.messages.data);
